import * as types from './types';

const initialState = {
  showBulkEntryModal: false,
  bulkEntry: {
    isLoading: false,
    isError: false,
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case types.SET_SHOW_BULK_ENTRY_MODAL:
      return {
        ...state,
        showBulkEntryModal: !!action.show,
      };
    case types.ADD_TIME_ENTRY_BULK:
      return {
        ...state,
        bulkEntry: {
          ...state.bulkEntry,
          isLoading: true,
          isError: false,
        },
      };
    case types.ADD_TIME_ENTRY_BULK_SUCCESS:
      return {
        ...state,
        bulkEntry: {
          ...state.bulkEntry,
          isLoading: false,
          isError: false,
        },
      };
    case types.ADD_TIME_ENTRY_BULK_ERROR:
      return {
        ...state,
        bulkEntry: {
          ...state.bulkEntry,
          isLoading: false,
          isError: true,
        },
      };
    default:
      return state;
  }
};
